import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Singleton } from '../../js/Singleton';
import { changePassIcon, successChange } from '../../Images/Images';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { consultingApp, noConsultingApp } from '../../redux/actions/A_reducer_consulting';
import { CUSTOM_COMPONENTS } from '../../js/customElements/customComponents';
import PasswordTextArea from '../workSpace/Others/PasswordTextArea';
import SingletonWebSocket from '../../js/Singletons/SingletonWebSocket';
import { INTEGRATION } from '../../constants';
import { Logger } from '../../js/helpers/Logger.js';
import { showAdminModal } from '../../redux/actions/A_Admin_Alert_Modal';
import AlertModalActions from '../../redux/actions/A_Alert_Modal';

class ConfigBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			onExit: false,
			password: '',
			newPassword: '',
			confirmPassword: '',
			passwordChanged: false,
			errorService: false
		};
		this.language = new Singleton();
		this.sharedData = new SingletonSharedData();
		let APIFact = new APIFactory();
		this.apiCont = APIFact.buildClient();
		this.hasError = true;
		this.setting207 = this.sharedData.getGeneralPermissions()[207];
	}

	componentDidMount() {
		if (this.props.messagesIntegrations.dataMessageIntegration && this.props.messagesIntegrations.dataMessageIntegration.subaction === INTEGRATION.CHANGE_PASSWORD) {
			this.setState({
				password: this.props.messagesIntegrations.dataMessageIntegration.aCurrentPassword,
				newPassword: this.props.messagesIntegrations.dataMessageIntegration.aNewPassword,
				confirmPassword: this.props.messagesIntegrations.dataMessageIntegration.aNewPassword
			});
			setTimeout(() => {
				this.changePassword();
			}, 2000);
		}
	}

	hasNumbers(str) {
		return /\d/.test(str);
	}
	hasLowerCase(str) {
		return str.toUpperCase() !== str;
	}
	hasUpperCase(str) {
		return str.toLowerCase() !== str;
	}
	hasSpecialCharacter(str) {
		return /\d/.test(str);
	}
	notEqualPassword() {
		if (!this.state.newPassword || !this.state.password) {
			this.hasError = true;
			return '';
		}
		if (this.state.newPassword === this.state.password) {
			this.hasError = true;
			return 'error';
		}
		return 'right';
	}
	more8Characters() {
		if (!this.state.newPassword) {
			this.hasError = true;
			return '';
		}
		if (this.state.newPassword.length <= 7) {
			this.hasError = true;
			return 'error';
		}
		return 'right';
	}
	upperLowerNumber() {
		if (!this.state.newPassword) {
			this.hasError = true;
			return '';
		}
		let pass = this.state.newPassword;
		if (!this.hasUpperCase(pass)) {
			this.hasError = true;
			return 'error';
		}
		if (!this.hasLowerCase(pass)) {
			this.hasError = true;
			return 'error';
		}
		if (!this.hasNumbers(pass)) {
			this.hasError = true;
			return 'error';
		}
		if (!this.hasSpecialCharacter(pass)) {
			this.hasError = true;
			return 'error';
		}
		return 'right';
	}
	newPassEqualsConfirmation() {
		if (!this.state.confirmPassword) {
			this.hasError = true;
			return '';
		}
		if (this.state.newPassword !== this.state.confirmPassword) {
			this.hasError = true;
			return 'error';
		}
		return 'right';
	}
	passAlredyExist(messageError) {
		this.props.showAlertModal({
			type: 'ModalAlert',
			title: this.language.getText('GUIPassAlreadyExistpssw-error-title'),
			message: messageError === 9999 ? this.language.getText('GUIPswModalAlertpswErrorBody') : this.language.getText('GUIPassAlreadyExistpssw-error-mssg'),
			button: this.language.getText('GUIPassAlreadyExistpssw-error-close'),
			secondButtonFtn: () => {},
			buttonFun: () => {}
		});
	}
	changePassword = () => {
		var errorList = [];
		if (this.notEqualPassword() === 'error') {
			errorList.push({ id: 5003, description: this.language.getText('error-5003') });
		}
		if (this.more8Characters() === 'error') {
			errorList.push({ id: 5002, description: this.language.getText('error-5002') });
		}
		if (this.upperLowerNumber() === 'error') {
			errorList.push({ id: 5006, description: this.language.getText('error-5006') });
		}
		if (this.newPassEqualsConfirmation() === 'error') {
			errorList.push({ id: 5001, description: this.language.getText('error-5001') });
		}

		let integrationMessage = { client: 'galatea', action: 'onErrorPasswordUpdate', data: errorList };
		let integrationMessageErrorXion;
		let _this = this;
		let objectResponse = this.apiCont.getObjectResponse();
		this.props.consultingApp();
		this.apiCont.changePassword(this.sharedData.getParameters().UserID, this.state.password, this.state.confirmPassword, this.state.newPassword, objectResponse);
		objectResponse.onError = function (messageError) {
			_this.passAlredyExist(messageError);
			errorList.push({ id: messageError.InternalCode, description: messageError.Message });
			integrationMessageErrorXion = {
				client: 'galatea',
				action: 'errorOnPasswordChange',
				data: { id: messageError.InternalCode, description: messageError.Message }
			};
			SingletonWebSocket.send(integrationMessage);
			SingletonWebSocket.send(integrationMessageErrorXion);
			_this.setState({
				errorService: true
			});
			setTimeout(() => _this.setState({ errorService: false }), 3000);
			_this.props.noConsultingApp();
		};
		objectResponse.onSuccess = function (objResponse) {
			Logger.Trace('SUCCESS CHANGE PASS===>> ', objResponse);
			integrationMessage = { client: 'galatea', action: 'onPasswordUpdated', data: errorList };
			SingletonWebSocket.send(integrationMessage);
			_this.props.noConsultingApp();
			_this.setState({ passwordChanged: true });
			setTimeout(() => {
				_this.closeWindow();
				_this.props.onCloseSettingBar();
			}, 1000);
		};
	};
	closeWindow() {
		this.props.onClose();
		this.setState({ onExit: true });
	}
	UNSAFE_componentWillUpdate() {
		this.hasError = false;
	}
	render() {
		return (
			<div className={'configBar ' + (this.state.onExit && 'onExit')}>
				{CUSTOM_COMPONENTS['configBarHeader'](changePassIcon, this.language.getText('GUIPasswordChangetitle'), () => this.closeWindow(), this.state.passwordChanged)}
				{this.state.passwordChanged ? (
					<div>
						<p className='txtPassChanged'>{this.language.getText('GUIPasswordChangesuccessChange')}</p>
						<img className='imgPassChanged' src={successChange} alt={'icon'}></img>
					</div>
				) : (
					<div>
						<p className={'changePassText'}>{this.language.getText('GUIPasswordChangecurrentPassword')}</p>
						<PasswordTextArea value={this.state.password} onChange={text => this.setState({ password: text })} />
						{this.state.errorService && <p className='txtErrorFloat'>{this.language.getText('GUIPasswordChangeincorrectPassword')}</p>}
						<p className={'changePassText'}>{this.language.getText('GUIPasswordChangenewPassword')}</p>
						<PasswordTextArea value={this.state.newPassword} onChange={text => this.setState({ newPassword: text })} />
						<p className={'passwordError ' + this.notEqualPassword()}>&#9679; {this.language.getText('error-5003')} </p> {/*Diferente a la anterior*/}
						<p className={'passwordError ' + this.more8Characters()}>&#9679; {this.language.getText('error-5002')} </p>
						{/*Al menos 8 caracteres*/}
						<p className={'passwordError marginBottom10 ' + this.upperLowerNumber()}>&#9679; {this.language.getText('error-5006')} </p>
						{/*"Debe contener una mayúscula, minuscúla y un número"*/}
						<p className={'changePassText'}>{this.language.getText('GUIPasswordChangeconfirmPassword')}</p>
						<PasswordTextArea value={this.state.confirmPassword} onChange={text => this.setState({ confirmPassword: text })} />
						<p className={'passwordError ' + this.newPassEqualsConfirmation()}>&#9679; {this.language.getText('error-5001')} </p>
						{/*"La contraseña y confirmación coinciden"*/}
						<div className={'buttonChangePassword ' + (this.hasError && 'inactive')} onClick={this.changePassword}>
							{this.language.getText('GUIPasswordChangetitle')}
						</div>
					</div>
				)}
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		messagesIntegrations: state.messagesIntegrations
	};
}

function mapDispatchToProps(dispatch) {
	const { showAlertModal } = AlertModalActions.creators;
	return {
		onShowAlertModal: payload => dispatch(showAdminModal(payload)),
		consultingApp: () => {
			dispatch(consultingApp());
		},
		noConsultingApp: () => {
			dispatch(noConsultingApp());
		},
		showAlertModal: payload => {
			dispatch(showAlertModal(payload));
		}
	};
}
export default ConfigBar = connect(mapStateToProps, mapDispatchToProps)(ConfigBar);



// WEBPACK FOOTER //
// ./src/components/Header/ChangePassBar.jsx